import videojs from 'video.js';

export default class CustomColors extends videojs.getPlugin('plugin') {
	constructor(player, options) {
		super(player, options);
		player.on('ready', () => {
			player.addClass('vjs-custom-colors');
			Object.keys(options)
				.filter((key) => options[key])
				.forEach((key) => player.el().style.setProperty(`--${key}`, options[key]));
		});
	}
}

videojs.registerPlugin('customColors', CustomColors);
